import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=53fc2d4c&scoped=true"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"
import style0 from "./_slug.vue?vue&type=style&index=0&id=53fc2d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fc2d4c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlaceCard: require('/workspace/components/PlaceCard.vue').default,PackageForm: require('/workspace/components/PackageForm.vue').default,ActivityCard: require('/workspace/components/ActivityCard.vue').default})
